import { render } from "./TasksOverviewChart.vue?vue&type=template&id=3fd1bd23&scoped=true&ts=true"
import script from "./TasksOverviewChart.vue?vue&type=script&lang=ts"
export * from "./TasksOverviewChart.vue?vue&type=script&lang=ts"

import "./TasksOverviewChart.vue?vue&type=style&index=0&id=3fd1bd23&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd1bd23"]])

export default __exports__